const landingGe = {
  title1: "Wir definieren",
  title2: "die digitale Zukunft",
  subHeading: "mit KI-gestützter digitaler Transformation",
  more: "Erfahren Sie mehr",
};

export default landingGe;
